export default __webpack_public_path__ + "static/media/movie-recording.893142f0.svg";